var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { ArrowRight } from 'pcln-icons';
import { Box, Card, Flex, Link, Text } from 'pcln-design-system';
var MEDIA_SIZE = 84;
var FlexCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "TripSummaryCard__FlexCard",
  componentId: "sc-121snix-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border: none;\n  box-shadow: ", ";\n  cursor: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border: none;\n  box-shadow: ", ";\n  cursor: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n  }\n"])), themeGet('shadows.sm'), function (props) {
  return props.onClick ? 'pointer' : 'default';
}, function (props) {
  return props.onClick && themeGet("shadows.".concat(props.hoverBoxShadowSize || 'xl'));
});
var Heading = /*#__PURE__*/styled(Text).withConfig({
  displayName: "TripSummaryCard__Heading",
  componentId: "sc-121snix-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"
/** @public */])), function (props) {
  return props.truncateHeading && "\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ";
});
/** @public */
function TripSummaryCard(_a) {
  var className = _a.className,
    actionText = _a.actionText,
    caption = _a.caption,
    body = _a.body,
    heading = _a.heading,
    handleSubmitCTA = _a.handleSubmitCTA,
    onClick = _a.onClick,
    hoverBoxShadowSize = _a.hoverBoxShadowSize,
    truncateHeading = _a.truncateHeading,
    showArrowRight = _a.showArrowRight,
    mediaNode = _a.mediaNode,
    _b = _a.mediaNodeBackgroundColor,
    mediaNodeBackgroundColor = _b === void 0 ? 'transparent' : _b,
    _c = _a.noTranslateHeading,
    noTranslateHeading = _c === void 0 ? false : _c,
    _d = _a.noTranslateCaption,
    noTranslateCaption = _d === void 0 ? false : _d;
  var translateHeadingConfig = noTranslateHeading ? {
    translate: 'no'
  } : {};
  var translateCaptionConfig = noTranslateCaption ? {
    translate: 'no'
  } : {};
  function handleKeyDown(e) {
    if (handleSubmitCTA && e.key === 'Enter') {
      handleSubmitCTA(e);
    }
  }
  return React.createElement(FlexCard, {
    "data-testid": 'trip-summary-card',
    borderRadius: 'xl',
    className: className,
    color: 'background.lightest',
    hoverBoxShadowSize: hoverBoxShadowSize,
    height: '100%',
    minHeight: MEDIA_SIZE,
    p: 2,
    role: onClick || handleSubmitCTA ? 'link' : '',
    tabIndex: onClick || handleSubmitCTA ? '0' : '-1',
    onClick: onClick,
    onKeyDown: handleKeyDown
  }, mediaNode && React.createElement(Box, {
    style: {
      alignSelf: 'stretch'
    }
  }, React.createElement(Flex, {
    borderRadius: 'md',
    color: mediaNodeBackgroundColor,
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: MEDIA_SIZE,
    maxWidth: MEDIA_SIZE,
    height: '100%',
    minHeight: MEDIA_SIZE,
    mr: 1
  }, React.cloneElement(mediaNode))), React.createElement(Flex, {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: 1,
    minWidth: 0
  }, React.createElement(Flex, {
    flexDirection: 'column',
    mx: 2,
    minWidth: 0
  }, React.createElement(Heading, __assign({
    mt: 1,
    fontWeight: 'bold',
    textStyle: 'heading5',
    truncateHeading: truncateHeading
  }, translateHeadingConfig), heading), caption && React.createElement(Text, __assign({
    mt: 1,
    textStyle: 'paragraph'
  }, translateCaptionConfig), caption), body && React.createElement(Box, {
    width: 1,
    mt: 1
  }, body), actionText && React.createElement(Link, {
    onClick: onClick,
    mt: 1
  }, React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Text, {
    textStyle: 'paragraphBold'
  }, actionText)))), onClick && showArrowRight && React.createElement(ArrowRight, {
    color: 'primary',
    size: 20,
    title: 'ArrowRight'
  })));
}
export default TripSummaryCard;
var templateObject_1, templateObject_2;